module.exports = __webpack_public_path__ + "media/donkey-kong.0bfec7cf.wav";